'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GlobalEventWrapper = require('./GlobalEventWrapper');

var _GlobalEventWrapper2 = _interopRequireDefault(_GlobalEventWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_CODES = ['Escape', // Escape
'Tab'];

/**
 * Component that alerts if you click outside of it
 */

var OutsideAlerter = function (_Component) {
  _inherits(OutsideAlerter, _Component);

  function OutsideAlerter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutsideAlerter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutsideAlerter.__proto__ || Object.getPrototypeOf(OutsideAlerter)).call.apply(_ref, [this].concat(args))), _this), _this.shouldTriggerAlert = function (event, wrapperNode) {
      // Only trigger if the event happens outside our target element.
      return !wrapperNode.contains(event.target);
    }, _this.handleClickOutside = function (event) {
      _this.props.onAlert(event);
    }, _this.handleKeyPress = function (event) {
      if (KEY_CODES.includes(event.key)) {
        _this.props.onAlert(event);
      }
    }, _this.globalEventHandlers = {
      keydown: [{
        callback: _this.handleKeyPress
      }],
      mousedown: [{
        callback: _this.handleClickOutside,
        conditional: _this.shouldTriggerAlert
      }]
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutsideAlerter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _GlobalEventWrapper2.default,
        {
          triggers: this.globalEventHandlers,
          className: this.props.className
        },
        this.props.children
      );
    }
  }]);

  return OutsideAlerter;
}(_react.Component);

OutsideAlerter.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element]).isRequired,
  onAlert: _propTypes2.default.func.isRequired
};

exports.default = OutsideAlerter;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/OutsideAlerter.js
// module id = 146
// module chunks = 0